import { makeStyles } from "@material-ui/core/styles";
import compete from "../../img/compete.gif"
import learn from "../../img/learn.gif"
import practice from "../../img/practice.gif"

export default makeStyles((theme) => ({

    main: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around",
        height: "100%",
        [theme.breakpoints.down('xs')]: {
            justifyContent: "space-between",
        },
    },
    options: {
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        flexWrap: "wrap",
        padding: "15px 15px 35px",
        margin: "0px 25px"
    },
    practice_button: {
        filter: "drop-shadow(4px 4px 3px #000000d3)",
        margin: "10px 15px",
        height: "230px",
        width: "290px",
        backgroundImage: `url(${practice})`,
        backgroundSize: "290px",
        transition: "transform 0.1s ease-in-out", // Added transition for smooth animation
        '&:hover': {
            transform: "scale(1.03)" // Scale up the button slightly on hover
        },
        [theme.breakpoints.down('xs')]: {
            width: "240px",
            height: "190px",
            margin: "0px"
        },
        [theme.breakpoints.down('sm')]: {
            margin: "20px 10px 35px"
        },
    },
    learn_button: {
        filter: "drop-shadow(4px 4px 3px #000000d3)",
        margin: "10px 15px",
        height: "230px",
        width: "290px",
        backgroundImage: `url(${learn})`,
        backgroundSize: "290px",
        transition: "transform 0.1s ease-in-out", // Added transition for smooth animation
        '&:hover': {
            transform: "scale(1.03)" // Scale up the button slightly on hover
        },
        [theme.breakpoints.down('xs')]: {
            width: "240px",
            height: "190px",
            margin: "0px"
        },
        [theme.breakpoints.down('sm')]: {
            margin: "20px 10px 35px"
        },
    },
    compete_button: {
        filter: "drop-shadow(4px 4px 3px #000000d3)",
        margin: "10px 15px",
        height: "230px",
        width: "290px",
        backgroundImage: `url(${compete})`,
        backgroundSize: "290px",
        transition: "transform 0.1s ease-in-out", // Added transition for smooth animation
        '&:hover': {
            transform: "scale(1.03)" // Scale up the button slightly on hover
        },
        [theme.breakpoints.down('xs')]: {
            width: "240px",
            height: "190px",
            margin: "0px"
        },
        [theme.breakpoints.down('sm')]: {
            margin: "20px 10px 35px"
        },
    },
    options_title: {
        color: "white",
        filter: "drop-shadow(3px 3px 2px #000000d3)",
        height: "40px",
    },
    options_text: {
        color: '#000000',
        backgroundColor: "#fffffff1",
        padding: "8px 15px",
        borderRadius: "10px",
        fontWeight: "bold",
        fontSize: "20px",
        marginTop: "220px"
    },
    final_title: {
        fontSize: "65px",
    },
    footer: {
        maxWidth: "400",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "30px 0px"
    },
    footer_button: {
        marginTop: "25px",
    },
    populares: {
        fontSize: "22px",
        color: "black",
        filter: "drop-shadow(3px 3px 3px white)",
        opacity: "75%",
        fontWeight: "bold",
        lineHeight: "48px"
    },
    noticia_aleatoria: {
        color: "white",
        filter: "drop-shadow(3px 3px 2px #000000d3)",
    },
}))
